import { VegaFlex } from '@globalpayments/vega-react';

import UserClientCard from './UserClientCard';
import { UserClientCardProps } from './UserClientCardProps';

interface Props {
  cards: UserClientCardProps[];
}

const UserClientCards: React.FC<Props> = ({ cards }) => {
  return (
    <VegaFlex direction="col" gap="size-16">
      {cards.map((card) => (
        <UserClientCard key={card.userClientUId} cardProps={card} />
      ))}
    </VegaFlex>
  );
};

export default UserClientCards;
